<template>
    <div class="recept">
        <!-- ========== 数据统计 ========== -->
        <div class="stat-row">
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#4F46E5"></span>好友总数</div>
                <div class="stat-value">{{ fmt(statData.friends) }}</div>
                <div class="stat-sub">{{ total }} 个企微账号合计</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#10B981"></span>真实好友</div>
                <div class="stat-value">{{ fmt(statData.real) }}</div>
                <div class="stat-sub">互相关注的双向好友</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#F59E0B"></span>单向好友</div>
                <div class="stat-value">{{ fmt(statData.single) }}</div>
                <div class="stat-sub">对方未添加，建议清理</div>
            </div>
            <div class="stat-card">
                <div class="stat-label"><span class="dot" style="background:#EF4444"></span>单向好友率</div>
                <div class="stat-value">{{ statData.rate }}<span class="unit">%</span></div>
                <div class="stat-sub">单向好友 ÷ 好友总数占比</div>
            </div>
        </div>

        <!-- ========== 工具栏 / 搜索 ========== -->
        <div class="toolbar">
            <el-select style="width:150px" v-model="searchdata.corp_ids" clearable placeholder="全部企微主体">
                <el-option v-for="(item, index) in corpList.data" :key="index" :label="item.corp_name" :value="item.id" />
            </el-select>
            <el-select style="width:130px" v-model="searchdata.is_wecom_disabled" clearable placeholder="全部企微状态">
                <el-option label="禁用" :value="1" />
                <el-option label="启用" :value="0" />
            </el-select>
            <el-select style="width:130px" v-model="searchdata.device_online" clearable placeholder="全部在线状态">
                <el-option label="离线" :value="0" />
                <el-option label="在线" :value="1" />
            </el-select>
            <el-input class="search-box" v-model="searchdata.name" placeholder="搜索别名 / 姓名…"  clearable />
            <el-button class="btn-ghost" @click="searchbtn">搜索</el-button>
            <el-button class="btn-ghost" @click="resbtn">重置</el-button>
            <div class="spacer"></div>
            <el-button class="btn-primary" @click="getonewaycustomer">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3.5-7.1"/><path d="M21 3v6h-6"/></svg>
                获取单向客户数量
            </el-button>
        </div>

        <!-- ========== 表格 ========== -->
        <div class="table-wrap">
            <el-table
                :data="tableData.data"
                style="width: 100%;"
                :header-cell-style="{ background: '#FBFCFE', color: '#64748B', fontSize: '12.5px' }"
                :row-class-name="rowClassName">
                <el-table-column label="姓名" min-width="230">
                    <template #default="scope">
                        <div class="acc-cell">
                            <el-avatar v-if="scope.row.avatar" :src="scope.row.avatar" :size="34" shape="square" class="acc-avatar" />
                            <span v-else class="acc-avatar" :style="{ background: 'linear-gradient(135deg,' + avatarColor(scope.$index) + ')' }">{{ initialName(scope.row.name) }}</span>
                            <div>
                                <div class="acc-name">{{ scope.row.name }}</div>
                                <div class="acc-alias">别名：{{ scope.row.alias }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="好友数" align="right" width="132">
                    <template #default="scope">{{ fmt(scope.row.total_num) }}</template>
                </el-table-column>
                <el-table-column label="真实好友数" align="right" width="142">
                    <template #default="scope">{{ fmt(scope.row.true_num) }}</template>
                </el-table-column>
                <el-table-column label="单向好友数量" align="right" width="152">
                    <template #default="scope">{{ fmt(scope.row.one_way_customer_count) }}</template>
                </el-table-column>
                <el-table-column label="在线状态" width="122">
                    <template #default="scope">
                        <span class="ops-badge" :class="scope.row.device_online == 1 ? 'ops-badge-online' : 'ops-badge-offline'">
                            {{ scope.row.device_online == 1 ? '在线' : '离线' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="企微账号状态" width="152">
                    <template #default="scope">
                        <span class="switch-wrap">
                            <label class="switch">
                                <input type="checkbox" :checked="scope.row.is_wecom_disabled == 0" @change="handleToggle(scope.row, $event)" />
                                <span class="slider"></span>
                            </label>
                            <span class="sw-text" :class="scope.row.is_wecom_disabled == 0 ? 'on' : 'off'">{{ scope.row.is_wecom_disabled == 0 ? '已启用' : '已禁用' }}</span>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pager">
                <el-pagination
                    :total="total"
                    :current-page="searchdata.page"
                    :page-size="searchdata.page_size"
                    layout="total, prev, next"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="page_change"
                />
            </div>
        </div>
    </div>

    <!-- 禁用确认弹窗 -->
    <el-dialog v-model="isshowdis" title="禁用账号" width="426px" :close-on-click-modal="false">
        <p class="dis-tip">确认禁用「<b>{{ nowrow.data.name }}</b>」？</p>
        <div class="alert-warn">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <path d="M12 9v4"/><path d="M12 17h.01"/>
            </svg>
            <div>
                <b>禁用后立即生效</b>
                <p>该账号将不再被消息触达、客户圈选引用，发送给其名下客户的消息将无法触达；历史会话与好友数据不受影响。</p>
                <p>如需恢复，随时可在列表中重新启用。</p>
            </div>
        </div>
        <template #footer>
            <div class="modal-actions">
                <el-button class="btn-ghost" @click="cancelDisable">取消</el-button>
                <el-button class="btn-primary" @click="confirmDisable">确认禁用</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { newgetneilistv2, newchgseatstatus, newgetonewaycustomer, newgetcomp2 } from '@/assets/js/common.js'

onMounted(() => {
    console.log('onMounted')
    getlist()
    getcorplist()
})

// 企微主体下拉
const corpList = reactive({
    data: []
})
// 获取企微主体下拉
const getcorplist = () => {
    newgetcomp2().then((response) => {
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
        }
    })
}

// 搜索
const searchdata = reactive({
    page: 1,
    page_size: 20,
    name: '',
    is_wecom_disabled: '',
    device_online: '',
    corp_ids: ''
})

// 列表数据
const tableData = reactive({
    data: []
})
// 总数
const total = ref(0)
// 统计（接口返回的 statistics 字段）
const statData = reactive({
    friends: 0,
    real: 0,
    single: 0,
    rate: 0
})
// 获取列表
const getlist = () => {
    var obj = JSON.parse(JSON.stringify(searchdata))
    obj.corp_ids = obj.corp_ids === '' || obj.corp_ids == null ? [] : [].concat(obj.corp_ids)
    newgetneilistv2(obj).then((response) => {
        if (response.data.msg.code == 0) {
            tableData.data = response.data.data.data
            total.value = response.data.data.total
            var st = response.data.data.statistics || {}
            statData.friends = st.total_num || 0
            statData.real = st.true_num || 0
            statData.single = st.one_way_customer_count || 0
            statData.rate = st.one_way_customer_rate != null ? st.one_way_customer_rate : 0
        }
    })
}

const fmt = (n) => Number(n || 0).toLocaleString('en-US')

// 头像渐变色
const avatarColors = [
    '#4F46E5,#7C3AED',
    '#0EA5E9,#2563EB',
    '#F59E0B,#EF4444',
    '#10B981,#059669',
    '#8B5CF6,#EC4899',
    '#0EA5E9,#22D3EE',
    '#F43F5E,#F97316',
    '#6366F1,#0EA5E9',
    '#14B8A6,#0EA5E9'
]
const avatarColor = (i) => avatarColors[i % avatarColors.length]

const initialName = (name) => {
    name = name || ''
    const i = name.indexOf('-')
    return i >= 0 ? name.charAt(i + 1) : name.charAt(0)
}

const rowClassName = ({ row }) => (row.is_wecom_disabled == 0 ? '' : 'row-off')

const searchbtn = () => {
    searchdata.page = 1
    getlist()
}
const resbtn = () => {
    searchdata.name = ''
    searchdata.is_wecom_disabled = ''
    searchdata.device_online = ''
    searchdata.corp_ids = ''
    searchdata.page = 1
    getlist()
}
const page_change = (val) => {
    searchdata.page = val
    getlist()
}

// 获取单向客户数量
const getonewaycustomer = () => {
    let cps = searchdata.corp_ids
    if (!Array.isArray(cps)) cps = cps === '' || cps == null ? [] : [cps]
    const params = {
        corp_id: cps.length ? cps[0] : '',
        corp_ids: cps,
        user_id: ''
    }
    newgetonewaycustomer(params).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '获取中，请稍后刷新页面',
                type: 'success',
            })
        }
    })
}

// ================= 企微账号状态切换（启用直接生效；禁用弹窗确认） =================
const isshowdis = ref(false)
const nowrow = reactive({ data: {} })

const handleToggle = (row, e) => {
    if (e.target.checked) {
        row.is_wecom_disabled = 0
        newchgseatstatus({ user_id: row.internal_user_id, is_wecom_disabled: 0 })
        ElMessage({ message: row.name + ' 已启用', type: 'success' })
    } else {
        // 弹窗确认前，先把开关视觉恢复为启用
        e.target.checked = true
        nowrow.data = row
        isshowdis.value = true
    }
}

const cancelDisable = () => {
    isshowdis.value = false
}

const confirmDisable = () => {
    newchgseatstatus({ user_id: nowrow.data.internal_user_id, is_wecom_disabled: 1 })
    nowrow.data.is_wecom_disabled = 1
    nowrow.data.device_online = 0
    isshowdis.value = false
    ElMessage({ message: nowrow.data.name + ' 已禁用', type: 'info' })
}
</script>
<style scoped>
.recept {
    font-size: 14px;
}

/* ---------- 统计卡片 ---------- */
.stat-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 18px;
}
.stat-card {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    padding: 16px 18px;
}
.stat-label {
    font-size: 12.5px;
    color: #64748B;
    font-weight: 600;
}
.stat-label .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
    vertical-align: middle;
}
.stat-value {
    font-size: 28px;
    font-weight: 800;
    color: #1E293B;
    margin-top: 4px;
    line-height: 1;
}
.stat-value .unit {
    font-size: 14px;
    font-weight: 600;
    color: #64748B;
    margin-left: 4px;
}
.stat-sub {
    font-size: 12px;
    color: #64748B;
    margin-top: 6px;
}

/* ---------- 工具栏 ---------- */
.toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}
.toolbar .spacer {
    flex: 1;
}

/* 下拉（白底+边框） */
:deep(.toolbar .el-select__wrapper) {
    background-color: #fff;
    box-shadow: 0 0 0 1px #E8ECF3 inset;
    border-radius: 10px;
    min-height: 36px;
    padding-left: 12px;
    padding-right: 12px;
}
:deep(.toolbar .el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 1px #4F46E5 inset;
}

/* 搜索输入（白底+边框） */
:deep(.toolbar .search-box .el-input__wrapper) {
    background-color: #fff;
    box-shadow: 0 0 0 1px #E8ECF3 inset;
    border-radius: 10px;
    min-height: 36px;
    padding-left: 12px;
    padding-right: 12px;
}
:deep(.toolbar .search-box .el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px #4F46E5 inset;
}
.search-box {
    width: 260px;
}

/* 按钮 */
.btn-ghost {
    background: #F1F3F9;
    color: #1E293B;
    border: 0;
    border-radius: 10px;
    font-weight: 600;
}
.btn-ghost:hover {
    background: #E7EAF2;
    color: #1E293B;
}
.btn-primary {
    background: linear-gradient(90deg, #4F46E5, #7C3AED);
    color: #fff;
    border: 0;
    border-radius: 10px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.btn-primary:hover {
    opacity: .92;
    color: #fff;
}

/* ---------- 表格 ---------- */
.table-wrap {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    padding: 6px 4px;
    overflow: hidden;
}
:deep(.el-table) {
    --el-table-border-color: #EEF1F6;
    --el-table-header-bg-color: #FBFCFE;
    font-size: 13.5px;
    --el-table-header-text-color: #64748B;
    background-color: #fff;
}
:deep(.el-table td.el-table__cell) {
    padding: 15px 18px;
    border-bottom: 1px solid #EEF1F6;
    vertical-align: middle;
}
:deep(.el-table th.el-table__cell) {
    padding: 14px 18px;
    border-bottom: 1px solid #E8ECF3;
    font-weight: 700;
}
:deep(.el-table .row-off) {
    color: #64748B;
}

/* 账号单元格 */
.acc-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}
.acc-avatar {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    flex-shrink: 0;
    display: grid;
    place-items: center;
    color: #fff;
    font-weight: 700;
    font-size: 14px;
}
.acc-name {
    font-weight: 700;
    line-height: 1.35;
    color: #1E293B;
}
.acc-alias {
    font-size: 12px;
    color: #64748B;
    margin-top: 2px;
}
.row-off .acc-avatar {
    filter: grayscale(1);
    opacity: .65;
}

/* 在线状态徽标 */
.ops-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    padding:12px 11px;
    height: 21px;
    border-radius: 999px;
    line-height: 1;
    vertical-align: middle;
}
.ops-badge::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    flex-shrink: 0;
}
.ops-badge-online {
    color: #10B981;
    background: rgba(16, 185, 129, .12);
}
.ops-badge-offline {
    color: #64748B;
    background: rgba(100, 116, 139, .12);
}

/* 设备状态开关 */
.switch-wrap {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    vertical-align: middle;
}
.switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 21px;
    flex-shrink: 0;
}
.switch input {
    display: none;
}
.switch .slider {
    position: absolute;
    inset: 0;
    background: #CBD5E1;
    border-radius: 999px;
    cursor: pointer;
    transition: background .18s;
}
.switch .slider::before {
    content: "";
    position: absolute;
    left: 3px;
    top: 3px;
    width: 15px;
    height: 15px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .18);
    transition: transform .18s;
}
.switch input:checked + .slider {
    background: linear-gradient(90deg, #10B981, #059669);
}
.switch input:checked + .slider::before {
    transform: translateX(17px);
}
.sw-text {
    font-size: 12.5px;
    font-weight: 700;
    white-space: nowrap;
}
.sw-text.on {
    color: #10B981;
}
.sw-text.off {
    color: #64748B;
}

/* ---------- 分页 ---------- */
.pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 14px 16px;
}
:deep(.el-pagination) {
    display: flex;
    align-items: center;
}
:deep(.el-pagination .el-pagination__total) {
    color: #64748B;
    font-size: 13px;
    margin-right: 10px;
}
:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next) {
    background: #fff;
    border: 1px solid #E8ECF3;
    border-radius: 8px;
    color: #1E293B;
    font-weight: 600;
    font-size: 13px;
    min-width: auto;
    padding: 0 12px;
    height: 32px;
    line-height: 30px;
}
:deep(.el-pagination .btn-prev) {
    margin-right: 8px;
}
:deep(.el-pagination .btn-prev:hover:not(:disabled)),
:deep(.el-pagination .btn-next:hover:not(:disabled)) {
    border-color: #4F46E5;
    color: #4F46E5;
}
:deep(.el-pagination .btn-prev:disabled),
:deep(.el-pagination .btn-next:disabled) {
    opacity: .5;
    background: #fff;
    color: #1E293B;
    cursor: not-allowed;
}

/* ---------- 禁用弹窗 ---------- */
.dis-tip {
    color: #64748B;
    margin: 4px 0 14px;
    font-size: 13.5px;
    line-height: 1.6;
}
.dis-tip b {
    color: #1E293B;
}
.alert-warn {
    display: flex;
    gap: 10px;
    background: rgba(245, 158, 11, .09);
    border: 1px solid rgba(245, 158, 11, .30);
    border-radius: 10px;
    padding: 11px 13px;
    color: #92400E;
}
.alert-warn > svg {
    flex-shrink: 0;
    margin-top: 1px;
    color: #F59E0B;
}
.alert-warn b {
    display: block;
    font-size: 13px;
    margin-bottom: 3px;
}
.alert-warn p {
    margin: 0;
    font-size: 12.5px;
    line-height: 1.65;
}
.alert-warn p + p {
    margin-top: 5px;
}
.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    width: 100%;
}

@media (max-width: 1180px) {
    .stat-row {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>